export enum SurveyWidgetDisplayMode {
    ReadWrite,
    ReadOnly
}